import React from 'react'
import { CheckmarkFilled } from '@carbon/icons-react'

const FloatingSubmit = (props) => {
  const { submitClicked } = props

  return (
    <span
      className='show-submit-container'
      onClick={() => {
        submitClicked()
      }}
    >
      <CheckmarkFilled className='submit-check-icon' />
    </span>
  )
}

export { FloatingSubmit }
